import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
    AppBar,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import AgGridTable from "src/app/main/utilities/AgGridTable";

const ViewLinkToCustomer = (props) => {
    const gridRef = useRef();
    const voucherGridRef = useRef();
    const [formOpen, setFormOpen] = useState(false);
    const [projectRowData, setProjectRowData] = useState([]);
    const [retailrowData, setRetailRowData] = useState([]);
    const [voucherRowData, setVoucherRowData] = useState([]);
    const [view, setView] = useState([]);
    const [viewDataOptions, setViewDataOptions] = useState([
        { label: "History", value: "History" },
        { label: "Related Voucher", value: "Related Voucher" },
    ]);
    const [projectGridApi, setProjectGridApi] = useState();
    const [voucherGridApi, setVoucherGridApi] = useState();
    const [retailGridApi, setRetalGridApi] = useState();
    const [projectColumnDefs, setProjectColumnDefs] = useState([
        {
            field: "date",
            headerName: "Date",
            minWidth: 150,
            checkboxSelection: false,
            headerCheckboxSelection: false,
        },
        { field: "user", headerName: "User", minWidth: 150 },
        { field: "event", headerName: "Event", minWidth: 150 },
        { field: "value", headerName: "Value", minWidth: 150 },
    ]);

    const [retailcolumnDefs, setRetailColumnDefs] = useState([
        {
            field: "p_term",
            headerName: "Payment Term",
            minWidth: 150,
            checkboxSelection: false,
            headerCheckboxSelection: false,
        },
        { field: "description", headerName: "Description", minWidth: 150 },
        { field: "from", headerName: "From", minWidth: 150 },
        { field: "to", headerName: "to", minWidth: 150 },
    ]);

    const [voucherColumnDefs, setVoucherColumnDefs] = useState([
        {
            field: "voucher_no",
            headerName: "Voucher No",
            minWidth: 150,
            checkboxSelection: false,
            headerCheckboxSelection: false,
        },
        { field: "date", headerName: "Date", minWidth: 150 },
        { field: "create_by", headerName: "Created By", minWidth: 150 },

    ]);

    const showPIData = () => {
        setFormOpen(true);
    };

    const handleViewClose = () => {
        setFormOpen(false);
    };

    const loadViewData = () => {
        const Viewdata = props.data;
    };

    const handleChangeViewData = (value) => {
        setView(value);
    };

    useEffect(() => {
        loadViewData();
    }, []);

    const projectOnGridReady = (params) => {
        setProjectGridApi(params.api);
    };

    const onVoucherGridReady = (params) => {
        setVoucherGridApi(params.api);
    };

    const retailOnGridReady = (params) => {
        setRetalGridApi(params.api);
    };

    return (
        <>
            <IconButton size="small" onClick={showPIData}>
                <FuseSvgIcon size={18}>heroicons-solid:eye</FuseSvgIcon>
            </IconButton>

            <Dialog
                open={formOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={"md"}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Proforma Invoice
                        </Typography>
                        <Button onClick={handleViewClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <div className="p-20">
                    <label>Proforma Invoice View Data</label>
                    <Select
                        name="viewData"
                        className="w-[25%] h-[100%] "
                        // className="w-[85px] h-[20px]"
                        value={
                            view &&
                            viewDataOptions.length > 0 &&
                            viewDataOptions.filter((list) => list === view)
                        }
                        onChange={handleChangeViewData}
                        options={viewDataOptions}
                        styles={customStyles("", "", "0px")}
                    />
                </div>
                {view.value === "History" ?
                    props.data.orderType === "PROJECT" ?
                        <>
                            <DialogTitle>
                                <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                                    <span>Proforma History</span>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2} className="mt-10">
                                    <Grid item xs={6}>
                                        <Stack>
                                            <label className=" float-left pr-5 pl-5 ">Customer</label>
                                            <TextField
                                                name="custnum"
                                                value={props.data.custNum}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="custnum"
                                            value={props.data.custName}
                                            // onChange={handlechangecompany}
                                            inputProps={{
                                                sx: { padding: "10px" },
                                            }}
                                            disabled
                                            style={{ marginTop: "20px" }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} className="mt-10">
                                    <Grid item xs={4}>
                                        <Stack>
                                            <label >Default Payment Terms</label>
                                            <TextField
                                                name="default_payment"
                                                value={props.data.custNum}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            name="default_payment"
                                            value={props.data.custName}
                                            // onChange={handlechangecompany}
                                            inputProps={{
                                                sx: { padding: "10px" },
                                            }}
                                            disabled
                                            style={{ marginTop: "20px" }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Stack>
                                            <label>Order Type</label>
                                            <TextField
                                                name="order_type"
                                                value={props.data.custNum}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                                <Divider className="mt-10" sx={{ borderBottomWidth: 3 }} />
                                <Grid container>
                                    <Grid item xs={12} className="h-[300px] mt-10">
                                        <AgGridTable
                                            onGridReady={projectOnGridReady}
                                            columnDefs={projectColumnDefs}
                                            rowData={projectRowData}
                                            gridRef={gridRef}
                                            floatingFilter={false}
                                            rowGroupPanelShow="never"
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </>
                        :
                        <DialogContent>

                            <Grid container spacing={1}>
                                <div className="flex items-baseline">
                                    <Grid item xs={6}>
                                        <div className="flex items-baseline">
                                            <label className=" float-left pr-5 pl-5 ">Customer</label>
                                            <TextField
                                                name="custnum"
                                                value={props.data.custNum}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="custnum"
                                            value={props.data.custName}
                                            // onChange={handlechangecompany}
                                            inputProps={{
                                                sx: { padding: "10px" },
                                            }}
                                            disabled
                                            style={{ marginTop: "-10px", marginLeft: "10px" }}
                                        />
                                    </Grid>
                                </div>
                                <Grid container spacing={1} className="mt-10">
                                    <Grid item xs={12}>
                                        <div className="flex items-baseline">
                                            <label className="float-left pr-5 ">Order Type</label>
                                            <TextField
                                                name="pi_number"
                                                value={props.data.pi_number}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider className="mt-10" sx={{ borderBottomWidth: 3 }} />
                            <Grid container>
                                <Grid item xs={12} className="h-[300px] mt-10">
                                    <AgGridTable
                                        onGridReady={retailOnGridReady}
                                        columnDefs={retailcolumnDefs}
                                        rowData={retailrowData}
                                        gridRef={gridRef}
                                        floatingFilter={false}
                                        rowGroupPanelShow="never"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                    :
                    view.value === "Related Voucher" && (
                        <>
                            <DialogTitle>
                                <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                                    <span>Related Vouchers Pop Up</span>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <div className="h-[300px]">
                                    <AgGridTable
                                        onGridReady={onVoucherGridReady}
                                        columnDefs={voucherColumnDefs}
                                        rowData={voucherRowData}
                                        gridRef={voucherGridRef}
                                        floatingFilter={false}
                                        rowGroupPanelShow="never"
                                    />
                                </div>
                            </DialogContent>
                        </>
                    )
                }

            </Dialog>
        </>
    );
};
export default ViewLinkToCustomer;

